function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "ic /2/ Twitter");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M24,0.0108168905 C22.9553291,0.722781286 21.7986631,1.26731982 20.5745455,1.62346228 C19.2287559,0.128379576 17.06004,-0.395913029 15.1440889,0.31063553 C13.2281378,1.01718409 11.9725094,2.80427799 12,4.78551206 L12,5.83952866 C8.10617981,5.93708042 4.42039125,4.14463889 2.18181818,1.06483348 C2.18181818,1.06483348 -2.18181818,10.5509828 7.63636364,14.7670492 C5.38966643,16.2405289 2.71326209,16.9793556 0,16.8750824 C9.81818182,22.1451654 21.8181818,16.8750824 21.8181818,4.75389156 C21.8171772,4.46029908 21.7879609,4.16743083 21.7309091,3.87905779 C22.8442943,2.8181828 23.6299935,1.47875928 24,0.0108168905 Z",
  id: "path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "News",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-/-News-Detail",
  transform: "translate(-160.000000, -491.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(152.000000, 480.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons-/-white-/-twitter-copy",
  transform: "translate(8.000000, 11.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#004E44",
  xlinkHref: "#path-1"
})))));

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "19px",
    viewBox: "0 0 24 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.02b7d977.svg";
export { ForwardRef as ReactComponent };